/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ImmobilieType {
    Eigenheim = 'Eigenheim',
    Mietwohnung = 'Mietwohnung',
    Eigentumswohnung = 'Eigentumswohnung',
    Reihenhaus = 'Reihenhaus',
    Einfamilienhaus = 'Einfamilienhaus',
    Mehrfamilienhaus = 'Mehrfamilienhaus',
    Gewerbeimmobilie = 'Gewerbeimmobilie',
    Ferienimmobilie = 'Ferienimmobilie'
  }

    export const ImmobilieTypeTranslocoMap: Record<ImmobilieType, string> = {
    [ImmobilieType.Eigenheim]: 'immobilieType.eigenheim',
    [ImmobilieType.Mietwohnung]: 'immobilieType.mietwohnung',
    [ImmobilieType.Eigentumswohnung]: 'immobilieType.eigentumswohnung',
    [ImmobilieType.Reihenhaus]: 'immobilieType.reihenhaus',
    [ImmobilieType.Einfamilienhaus]: 'immobilieType.einfamilienhaus',
    [ImmobilieType.Mehrfamilienhaus]: 'immobilieType.mehrfamilienhaus',
    [ImmobilieType.Gewerbeimmobilie]: 'immobilieType.gewerbeimmobilie',
    [ImmobilieType.Ferienimmobilie]: 'immobilieType.ferienimmobilie',
    };

    export const ImmobilieTypeOptions = [
  { value: ImmobilieType.Eigenheim, labelKey: 'immobilieType.eigenheim' },
  { value: ImmobilieType.Mietwohnung, labelKey: 'immobilieType.mietwohnung' },
  { value: ImmobilieType.Eigentumswohnung, labelKey: 'immobilieType.eigentumswohnung' },
  { value: ImmobilieType.Reihenhaus, labelKey: 'immobilieType.reihenhaus' },
  { value: ImmobilieType.Einfamilienhaus, labelKey: 'immobilieType.einfamilienhaus' },
  { value: ImmobilieType.Mehrfamilienhaus, labelKey: 'immobilieType.mehrfamilienhaus' },
  { value: ImmobilieType.Gewerbeimmobilie, labelKey: 'immobilieType.gewerbeimmobilie' },
  { value: ImmobilieType.Ferienimmobilie, labelKey: 'immobilieType.ferienimmobilie' },
    ];

